const matrix = { row: 7, col: 7 };

const levelsData = [
  {
    matrix,
    player: { x: 0, y: 0 },
    lights: 1,
    facing: "DOWN",
    optimal: 3,
    procedure: false,
    tileMap: [[4], [4], [2]]
  },
  {
    matrix,
    player: { x: 0, y: 0 },
    lights: 1,
    facing: "DOWN",
    optimal: 9,
    procedure: false,
    tileMap: [
      [4, 0, 2],
      [4, 0, 4],
      [4, 4, 4]
    ]
  },
  {
    matrix,
    player: { x: 2, y: 0 },
    lights: 1,
    facing: "UP",
    optimal: 7,
    procedure: false,
    tileMap: [
      [4, 1, 4],
      [4, 0, 1],
      [4, 0, 2]
    ]
  },
  {
    matrix,
    player: { x: 0, y: 0 },
    lights: 1,
    facing: "RIGHT",
    optimal: 10,
    procedure: false,
    tileMap: [
      [4, 1, 4],
      [0, 0, 1],
      [4, 1, 4],
      [1, 0, 0],
      [4, 1, 2]
    ]
  },
  {
    matrix,
    player: { x: 0, y: 3 },
    lights: 3,
    facing: "DOWN",
    optimal: 14,
    procedure: true,
    tileMap: [
      [2, 0, 0, 4],
      [4, 0, 0, 4],
      [4, 0, 0, 4],
      [2, 4, 4, 2]
    ]
  },
  {
    matrix,
    player: { x: 0, y: 0 },
    lights: 1,
    facing: "DOWN",
    optimal: 16,
    procedure: true,
    tileMap: [
      [4, 0, 0, 0, 0],
      [4, 4, 0, 0, 0],
      [0, 4, 4, 0, 0],
      [0, 0, 4, 4, 0],
      [0, 0, 0, 4, 2]
    ]
  },
  {
    matrix,
    player: { x: 4, y: 0 },
    lights: 1,
    facing: "UP",
    optimal: 13,
    procedure: true,
    tileMap: [
      [4, 4, 4, 1, 4],
      [1, 0, 0, 0, 4],
      [4, 0, 2, 0, 4],
      [4, 0, 4, 0, 1],
      [4, 0, 4, 4, 4]
    ]
  }
];

export const createLevelMap = (levelData, index) => {
  let matrix = levelData.matrix,
    tileMap = levelData.tileMap,
    player = levelData.player,
    data = Array.from({ length: matrix.row })
      .fill(null)
      .map(v => Array.from({ length: matrix.col }).fill(0)),
    topLeft = {
      x: parseInt(matrix.row / 2) - parseInt(tileMap.length / 2),
      y:
        parseInt(matrix.col / 2) -
        parseInt(Math.max(...tileMap.map(v => v.length)) / 2)
    };
  for (let i = 0; i < tileMap.length; i++)
    for (let j = 0; j < tileMap[i].length; j++)
      data[topLeft.x + i][topLeft.y + j] = tileMap[i][j];
  return {
    metadata: {
      row: matrix.row,
      col: matrix.col,
      playerX: topLeft.x + player.x,
      playerY: topLeft.y + player.y,
      direction: levelData.facing,
      totalLights: levelData.lights,
      index: index,
      optimalSolution: levelData.optimal,
      procedure: levelData.procedure
    },
    data
  };
};

export const levelsMap = levelsData.map(level => createLevelMap(level));